import React from 'react';
import { addressSubdivisions, subdivisionValue } from '../common/addressSubdivisions';

export default function AddressSubdivisionField({ country, value, onChange, disabled, required, className, label = 'State / Province / Area' }: {
    country: string; value: string; onChange: (value: string) => void; disabled?: boolean; required?: boolean;
    className: string; label?: string;
}) {
    const regions = addressSubdivisions(country);
    const normalized = subdivisionValue(country, value || '');
    return <label className="block text-xs font-bold uppercase tracking-wide text-slate-500">{label}
        {regions.length ? <select required={required} disabled={disabled || !country} value={normalized} onChange={event => onChange(event.target.value)} className={className}>
            <option value="">Select state or province</option>
            {normalized && !regions.some(region => region.name === normalized) && <option value={normalized}>{normalized}</option>}
            {regions.map(region => <option key={region.code} value={region.name}>{region.name}</option>)}
        </select> : <input disabled={disabled || !country} value={value || ''} onChange={event => onChange(event.target.value)} className={className} placeholder={country ? 'Enter state, province, or area' : 'Select country first'} />}
    </label>;
}
